import { render, staticRenderFns } from "./TradingMarketTab.vue?vue&type=template&id=7d933838"
import script from "./TradingMarketTab.vue?vue&type=script&lang=js"
export * from "./TradingMarketTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports